(function () {

  'use strict';

  function pxListMenu() {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        menuItems: '=menuItems',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/directives/listMenu/listMenu.template.html',
      link: function (scope) {

        scope.selectMenuItem = function (event, menuItem) {
          event.stopPropagation();
          scope.callback({ context: scope.context, action: menuItem.action });
        };

        scope.closeListMenu = function () {
          scope.callback({ context: null, action: null });
        };

      }
    };
  }

  pxListMenu.$inject = [];

  angular
    .module('printix-admin')
    .directive('pxListMenu', pxListMenu);

})();
